import React from "react";
import { emailVerifyFields } from "../../../utils/utils";
import FormField from "../utilComponents/FormField";
import Divider from "../../shared/Divider";
import { Link } from "react-router-dom";

import Lottie from "lottie-react";
import emailSentAnimation from "../../../lottieJsons/email-sent.json";

import { useDispatch, useSelector } from "react-redux";

import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormButton from "../../shared/FormButton";
import { sendEmailVerification } from "../../../features/auth/actions/auth";

const EmailVerifySchema = Yup.object().shape({
  email: Yup.string()
    .email("Please enter a valid email")
    .max(45)
    .required("This field is required"),
});

const EmailVerify = () => {
  const dispatch = useDispatch();

  // const [loading, setLoading] = React.useState(false);
  const emailSuccess = useSelector((state) => state.auth.emailSuccess);
  const loading = useSelector((state) => state.auth.loading);

  return (
    <>
      {emailSuccess ? (
        <div className="flex flex-col justify-center items-center my-8">
          <Lottie
            animationData={emailSentAnimation}
            loop={false}
            style={{ width: "100px", height: "100px" }}
          />
          <p>Verification email sent successfully. Please check your inbox.</p>
        </div>
      ) : (
        <>
          <div className="mb-8">
            <div className="font-bold text-lg">Verify your email</div>
            <div>
              Please enter your email to get it verified before creating your
              account.
            </div>
          </div>
          <Formik
            initialValues={{
              email: "",
            }}
            validationSchema={EmailVerifySchema}
            onSubmit={(values) => {
              dispatch(sendEmailVerification(values));
            }}
          >
            {() => (
              <Form>
                {emailVerifyFields.map((field) => (
                  <FormField key={field.name} {...field} />
                ))}
                <div className="flex justify-start mb-2">
                  Have an account? &nbsp;{" "}
                  <Link to="/" className="text-[#3e4095]">
                    Click here
                  </Link>
                </div>
                <Divider />
                <FormButton
                  isSubmitting={loading}
                  buttonText="Send email to verify"
                />
              </Form>
            )}
          </Formik>
        </>
      )}
    </>
  );
};

export default EmailVerify;
